import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './page/page.component';
import { HomeComponent } from './home/home.component';
import { InterviewComponent } from './interview/interview.component';


const routes: Routes = [
  // { path: '', redirectTo: 'home', pathMatch: 'full'},
  // { path: 'home', component: HomeComponent },
  { path: '', component: HomeComponent , pathMatch: 'full'},
  { path: 'entrevistas', component: InterviewComponent },
  { path: 'entrevistas/:id', component: InterviewComponent },
  { path: 'elkarrizketak', component: InterviewComponent },
  { path: 'elkarrizketak/:id', component: InterviewComponent },
  { path: ':id', component: PageComponent },
  { path: ':parent/intro', redirectTo:':parent'},
  { path: ':parent/:id', component: PageComponent},
  { path: ':parent/:subparent/:id', component: PageComponent},
  { path: '**', component: HomeComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})

export class AppRoutingModule { }
